const ECONOMY_LABELS: Record<string, string> = {
  posted: 'Обработано',
  withdrawn: 'Снято: отчёт открыт снова, затраты сторнированы',
  awaiting_valuation: 'Ожидает оценки и согласования',
  pending_delivery: 'Ожидает передачи в экономику',
  delivery_failed: 'Ошибка передачи в экономику',
  not_ready: 'Данные о проведении ещё не готовы',
  not_applicable: 'Отчёт ещё не принят',
};

const SIDE_LABELS: Record<string, string> = {
  applied: 'Записано',
  skipped: 'Не требуется',
  not_ready: 'Ещё не готово',
  not_applicable: 'Отчёт ещё не принят',
};

export function PostingStatus({
  data,
  loading,
}: {
  data?: { schedule: string; economy: string; warehouse?: string; resources?: string };
  loading: boolean;
}) {
  const unavailable = loading ? 'Загрузка статуса…' : 'Статус недоступен';
  return (
    <>
      <p className="text-sm">
        График: {!data ? unavailable : data.schedule === 'applied' ? 'Факт записан' : 'Ожидает подтверждения'}
      </p>
      <p className="mt-2 text-sm">
        Табель: {!data?.resources ? unavailable : (SIDE_LABELS[data.resources] ?? 'Статус неизвестен')}
      </p>
      <p className="mt-2 text-sm">
        Склад: {!data?.warehouse ? unavailable : (SIDE_LABELS[data.warehouse] ?? 'Статус неизвестен')}
      </p>
      <p className="mt-2 text-sm">
        Экономика: {data ? (ECONOMY_LABELS[data.economy] ?? 'Статус неизвестен') : unavailable}
      </p>
    </>
  );
}
